import { Store } from 'redux';
import * as React from 'react';
import { Router, Route, HistoryBase } from 'react-router';
import ConnectedLocale from 'containers/ConnectedLocale';
import { Provider } from 'react-redux';
import { getReferralCodeRoute } from './ReferralCodeRoute';
import { getLegacyRoute } from './LegacyRoute';
import { getAntRootRoute } from './AntRootRoute';
import { getMobileRoute } from './MobileRoute';
import { getDashboardRoute } from './DashboardRoute';
import { getAdminRoute } from './AdminRoute';
import Page404 from '../containers/404Page';

interface RootProps {
  store: Store<RootState>;
  history: HistoryBase;
  homeRoot: string;
}

/**
 * Relevant resources:
 * [history](https://github.com/rackt/history/tree/master/docs)
 * [react-router/history](https://github.com/rackt/react-router/blob/master/docs/guides/basics/Histories.md)
 */
const Root = ({ store, history, homeRoot }: RootProps) => {
  return (
    <Provider store={store}>
      <ConnectedLocale>
        <Router
          onUpdate={() => {
            // Remove splash
            if (document) {
              const element = document.getElementById('splash');
              if (element) {
                element.outerHTML = '';
              }
            }
            window.scrollTo(0, 0);
          }}
          history={history}
        >
          {getReferralCodeRoute()}
          {getLegacyRoute(store, homeRoot)}
          {getAntRootRoute()}
          {getMobileRoute()}
          {getDashboardRoute(store)}
          {getAdminRoute(store)}

          <Route path="*" component={Page404} />
        </Router>
      </ConnectedLocale>
    </Provider>
  );
};

export default Root;



// WEBPACK FOOTER //
// ./app/routers/Root.tsx